import { useEffect, useState } from 'react';
import { trpc } from '../../../utils/trpc/trpc.ts';
import { PeriodOptionSet } from '../period-selection/createPeriodOptions.ts';
import { getDefaultReportSettings } from './getDefaultSettings.ts';
import { ReportSettings } from './reportSettings.ts';


const DEFAULT_TARGET_VALUE = '0.9';

export function useReportSettings(periodOptionSet: PeriodOptionSet) {
    const [reportSettings, setReportSettings] = useState(getDefaultReportSettings(periodOptionSet, DEFAULT_TARGET_VALUE));

    const { data: sharedTargetValue } = trpc.appSettings.getAvailabilityTargetValue.useQuery(undefined, {
        refetchOnWindowFocus: false,
    });
    const setSharedTargetValue = trpc.appSettings.setAvailabilityTargetValue.useMutation();


    useEffect(() => {
        if (sharedTargetValue == null) return;
        setReportSettings((prev) => {
            if (prev.availabilityTargetValue === sharedTargetValue) {
                return prev;
            }
            return {
                ...prev,
                availabilityTargetValue: sharedTargetValue,
            };
        });
    }, [sharedTargetValue]);

    function handleReportSettingsChange(newSettings: ReportSettings) {
        const previousTargetValue = reportSettings.availabilityTargetValue ?? DEFAULT_TARGET_VALUE;
        const newTargetValue = newSettings.availabilityTargetValue ?? '';

        setReportSettings(newSettings);

        if (newTargetValue !== previousTargetValue) {
            setSharedTargetValue.mutate(newTargetValue, {
                onError: () => {
                    alert('Failed to save target value');
                },
            });
        }
    }

    return {
        reportSettings,
        setReportSettings: handleReportSettingsChange,
    };
}
